/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Questionnaire } from './Questionnaire';
import './style.scss';

const CustomerFeedbackPage = () => {
    const navigate = useNavigate();
    const [stopAreaId, setStopAreaId] = useState();
    const [surveyTypeId, setSurveyTypeId] = useState();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    useEffect(() => {
        const stopIdFromUrl = urlParams.get('stop');
        const surveyIdFromUrl = urlParams.get('survey');
        if (!stopIdFromUrl || !surveyIdFromUrl) {
            navigateToErrorPage();
        } else {
            setStopAreaId(parseInt(stopIdFromUrl));
            setSurveyTypeId(parseInt(surveyIdFromUrl));
        }
    }, []);

    const navigateToErrorPage = () => {
        return navigate('/error');
    };

    return <Questionnaire stopAreaId={stopAreaId} surveyTypeId={surveyTypeId} />;
};

export default CustomerFeedbackPage;
